import { createApp } from "vue";
import { MAINCONFIG, releaseSessionGate } from "./mainconfig.js"; // Import objek MAINCONFIG
import App from "./App.vue";
import store from "./store"; // Import Vuex store
import router from "./router"; // Import router
import pkg from "../package.json";
import { watchForNewBuild } from "./utils/appVersion";

// Cetak versi + sidik jari build ke console (tidak ada di UI), sekaligus mulai mengawasi
// apakah server sudah memasang build yang lebih baru. Lihat src/utils/appVersion.js.
watchForNewBuild(`${pkg.name} v${pkg.version}`);

//Others
import Skeleton from "@brayamvalero/vue3-skeleton";
import { vMaska } from "maska/vue"; // Import Maska directive
import { createHead } from "@vueuse/head";
import VueLazyload from "vue-lazyload";
//CSS
import "maz-ui/styles"; // Import Maz UI CSS
import "./assets/styles/main.css";
import "@splidejs/vue-splide/css";
import "@brayamvalero/vue3-skeleton/dist/style.css";
import "leaflet/dist/leaflet.css";
import defaultImage from "@/assets/images/400x300.webp";
//Utils
import formatters from "./utils/formatters";
import { getAndSendFingerprint } from "@/utils/fingerprint";
//Components
import BaseComponents from "./components/base";
import ModuleComponents from "./components/modules";
//Plugins
import responseMappingPlugin from "@/plugins/responseMapping";
import alertPlugin from "@/plugins/AlertPlugin.js";
import i18n, { loadLocaleMessages } from "./plugins/LanguageComponent.js"; // Import i18n dan fungsi lazy-load
import IconComponent from "./plugins/IconComponent"; // Import IconComponent
import setupAnalytics from "./plugins/analytics"; // Google Analytics (GA4)
// import '../src/assets/styles/property-details.css'
// import '../src/assets/styles/odometer-theme-default.css'
import AOS from "aos";
import "aos/dist/aos.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import moment from "moment";
AOS.init();

const app = createApp(App);
const head = createHead();

// Registrasi komponen global
Object.entries(ModuleComponents).forEach(([name, component]) => {
    app.component(name, component);
});

(async () => {
    // Muat bahasa dari cookies atau gunakan default (fallback)
    const currentLanguage = store.state.language.currentLanguage || "en";
    await loadLocaleMessages(currentLanguage); // Pastikan bahasa dimuat sebelum aplikasi dirender

    // Gunakan plugin dan konfigurasi
    app.use(BaseComponents);
    app.use(router); // Gunakan router
    setupAnalytics(app, router); // GA4 — auto page_view per route (no-op jika VUE_APP_GA_ID kosong)
    app.use(Skeleton); // Gunakan Skeleton
    app.directive("maska", vMaska); // Gunakan Maska untuk masking input
    app.use(store); // Gunakan store
    app.use(i18n); // Gunakan i18n
    app.use(head); // Gunakan vue-use-head untuk SEO
    app.use(VueLazyload, {
        preLoad: 1.3,
        error: defaultImage, // Gambar default untuk error
        loading: defaultImage, // Gambar default untuk loading
        attempt: 3, // Coba ulang hingga 3 kali
        observer: true, // Gunakan IntersectionObserver untuk lazy loading
        observerOptions: {
            rootMargin: "0px", // Tambahan jarak untuk trigger lazy loading
            threshold: 0.1, // 10% elemen terlihat sebelum memuat gambar
        },
    });
    app.use(IconComponent); // Gunakan IconComponent untuk registrasi global
    app.use(responseMappingPlugin); // Plugin untuk respons API
    app.use(formatters); // Format Bilangan
    app.use(alertPlugin);

    // Properti global
    app.config.globalProperties.$config = MAINCONFIG;
    app.config.globalProperties.$moment = moment;
    // Mount DULU, sesi menyusul. Menahan mount sampai fingerprint + /user/guest selesai
    // berarti layar kosong untuk pengunjung pertama kali (yang belum punya cookie
    // fingerprint_id justru harus menghitungnya dulu) — terukur ~0,8 dtk di atas biaya
    // muat JS. Request ber-`requiresAuth` tetap aman karena digerbangi `sessionReady`
    // di interceptor (mainconfig.js), bukan oleh urutan mount.
    router.isReady().then(() => {
        app.mount("#app");
        bootstrapSession();
    });

    // Token guest terbit di tengah bootstrap (fetchUser di dalam sendFingerprint sendiri
    // ber-requiresAuth), jadi gerbangnya dilepas begitu token ada — bukan di akhir —
    // supaya bootstrap tidak menunggu dirinya sendiri.
    store.subscribe((mutation) => {
        if (mutation.type === "user/setToken") releaseSessionGate();
    });

    async function bootstrapSession() {
        try {
            const token = localStorage.getItem("token");
            if (token) {
                releaseSessionGate(); // token sudah ada — tak ada yang perlu ditunggu
                // Jika token ada, coba validasi melalui fetchUser
                await store.dispatch("user/fetchUser");
                try {
                    await store.dispatch("user/getWebsiteSetting");
                } catch (error) {
                    console.log("GETSETTING", error);
                }
            } else {
                // Jika tidak ada token, langsung gunakan fingerprint untuk sesi guest
                console.log("SENDF", 3);
                await getAndSendFingerprint(store);
            }
        } catch (error) {
            console.warn(
                "Failed to fetch user. Falling back to fingerprint authentication."
            );
            await getAndSendFingerprint(store);
            console.log("SENDF", 4, error);
        } finally {
            releaseSessionGate(); // idempoten; jaring pengaman kalau sesi gagal terbit
        }
    }
})();
